module.exports = __webpack_public_path__ + "img/PS43.090d0c0f.png";